import { ApplicationRecord } from '../spraypaint';

function graphitiLanguageObserver(newLanguage: string) {
  ApplicationRecord.language = newLanguage;
}

export default graphitiLanguageObserver;
